import type { PropsWithChildren, ReactElement } from "react";
import {
    StyledWizardHintText,
    StyledWizardLinkButton
} from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/components/WizardLinkButton/styles";
import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

interface Props {
    onClick: () => void;
}

const WizardLinkButton = ({ onClick }: PropsWithChildren<Props>): ReactElement => {
    return (
        <div>
            <I18n element={StyledWizardHintText}
                  translatable={{ key: 'si.onboarding.wizard.skip-text' }} />

            <StyledWizardLinkButton
                onClick={onClick}>{translate('si.onboarding.wizard.to-platform-link-text')}</StyledWizardLinkButton>
        </div>
    )
}

export default WizardLinkButton;